import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { QuestionnaireService } from '../services/questionnaire.service';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormBuilder, Validators, AbstractControl, FormControl } from '@angular/forms';
import { data } from '../../israel-cities';
import { dataBabks } from '../banks';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { SystemTablesService } from "../services/system-tables.service";
import { MatAutocompleteModule } from '@angular/material/autocomplete'; //for auto complete
// import { IncomesArrayComponent } from '../incomes-array/incomes-array.component';
import { CycleMixtureComponent } from '../cycle-mixture/cycle-mixture.component';
import { mizrahiTefhotBranches } from '../mizrahi tefaho branchs';
import { InternalTikNumArrayComponent } from '../internal-tik-num-array/internal-tik-num-array.component';
import { InternalMaslolComponent } from '../internal-maslol-array/internal-maslol-array.component';


@Component({
	selector: 'app-cycle-details',
	templateUrl: './cycle-details.component.html',
	styleUrls: ['./cycle-details.component.scss']
})
export class CycleDetailsComponent implements OnInit {
	private route$: Subscription;
	qID;
	prevQID: any;
	currentStep;
	visibleQids;
	currentStepName;
	cycleDetails: FormGroup;
	submitted;
	editQuestion;

	isAdvisor: boolean = false;
	cycleType: string = null;

	optionsPurpose;
	selectedOptionPurpose;

    DATABanks: any = dataBabks;
	public banksList; // banks from LU Table
	banksFilterList: Observable<any[]>;
	externalBank: FormControl;
    checkBank: number = 0;
    arrbank = [];

	DATACities: any = data;
	public citiesList;
	cityFilterList: Observable<any[]>;
	inWhichCity: FormControl;

	public optionsMakorPurposeList: any[];
	optionsMakorPurposeFilterList: Observable<any[]>;
	checkProposeMakor:number = 0;
	externalMakorPropose: FormControl;

	//internal select product
	productsList: string[] = ["קבועה צמודה", "קבועה לא צמודה", "פריים", "משתנה 5 צמודה", "משתנה 5 לא צמודה", "משתנה 7"];
	defaultValue = "";
    branchList;	

	qFields = {
		1: [{ name: "cyclePurpose", validators: []}],
		2: [{ name: "cycleAmount", validators: [Validators.required] }],
		'2-0': [{ name: "isHigherThanTheExistingOne", validators: [] } ],
		'2-1': [{ name: "cycleMixture", validators: [] } ],
		3: [{ name: "externalBank", validators: [Validators.required, this.isInBankList()]}],
		4: [{ name: "externalMakorPropose", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] }],
		5: [{ name: "externalMortgageBalance", validators: [Validators.required] }],
		6: [{ name: "externalMonthlyRepayment", validators: [Validators.required] }],
		7: [{ name: "inWhichCity", validators: [Validators.required, this.isInCityList()]}],
        8: [{ name: "externalValueOfProperty", validators: [Validators.required] }],
		9: [{ name: "internalAreCycleAllMorygage", validators: [] }],
		'9-1': [{ name: "internalCycleAmount", validators: [Validators.required] }],
		'9-2': [{ name: "internalTikNum", validators: [] } ],
		'9-3': [{ name: "internalMaslol", validators: [] } ],
        // '9-4': [{ name: "internalProduct", validators: [Validators.required] }],
        '10': [{ name: "continueBranch", validators: [Validators.required] }],
        '11': [{ name: "oshBank", validators: [Validators.required] }]
		
	};

	qArrFields = {
		'9-2': [
			{ name: "internalTikNum", validators: [Validators.required,Validators.pattern("^[0-9]{7,12}$")] }
		],
		'9-3': [
			{ name: "internalMaslol", validators: [Validators.required,Validators.pattern("^[0-9]{1,3}$")] }
		],
		'2-1': [
				{ name: "type", validators: [Validators.required]},
				{ name: "amount", validators: [Validators.required] }
		]
	};

	constructor(
		private questionnaireService: QuestionnaireService,
		private activeRoute: ActivatedRoute,
		private router: Router,
		public translate: TranslateService,
        private fb: FormBuilder,
        private systemTablesService: SystemTablesService
	) {
		this.currentStep = this.questionnaireService.getStep("cycle-details");
		
		// for banks
        this.banksList = this.DATABanks.banks;
		this.externalBank = new FormControl(this.questionnaireService.getQuestion(this.currentStep, "3").answer.fields[0].answerValue);
		this.banksFilterList = this.externalBank.valueChanges
			.pipe(
				startWith(''),
				map(bank => bank ? this.filterBanks(bank) : this.banksList.slice())
			);

		// for makor loan propose
		this.optionsMakorPurposeList = [
			{label:"קניית דירה מקבלן"},
			{label:"קניית דירה יד שניה"},
			{label:"שיפוצים"},
			{label:"קניית מגרש"},
			{label:"בניה עצמית"},
			{label:"הרחבה"},
			{label:"הלוואה לכל מטרה"}
		];
		this.externalMakorPropose = new FormControl(this.questionnaireService.getQuestion(this.currentStep, "4").answer.fields[0].answerValue);
		this.optionsMakorPurposeFilterList = this.externalMakorPropose.valueChanges
			.pipe(
				startWith(''),
				map(prop => prop ? this.filterProposeMakor(prop) : this.optionsMakorPurposeList.slice())
			);

		// for cities:
		this.citiesList = this.DATACities.Cities;
		this.inWhichCity = new FormControl(this.questionnaireService.getQuestion(this.currentStep, "7").answer.fields[0].answerValue);
		this.cityFilterList = this.inWhichCity.valueChanges
			.pipe(
				startWith(''),
				map(city => city ? this.filterCity(city) : this.citiesList.slice())
        );

        this.branchList = mizrahiTefhotBranches;
	}

	ngOnInit() {

		this.isAdvisor = this.questionnaireService.getIsAdvisor();
        this.cycleType = this.questionnaireService.getCycleType();
        // this.getSystemTbl();
		this.createForm();

		// option for q1
		this.optionsPurpose=[
			{label:'CYCLE_DETAILS.Q1.A1',id:"extensionPeriod",class:"key"},
			{label:'CYCLE_DETAILS.Q1.A2',id:"improveRate",class:"home"},
			{label:'CYCLE_DETAILS.Q1.A3',id:"shortPeriod",class:"renovation"},
			{label:'CYCLE_DETAILS.Q1.A4',id:"takeCredit",class:"plot"}
		];
		this.selectedOptionPurpose="3";


		this.route$ = this.activeRoute.params.subscribe(params => {
			console.log("-----------------------------> params", params);
			this.prevQID = this.qID;
			this.qID = params.qid;
			this.editQuestion=null;
			this.currentStepName = "cycle-details";

			if (params.qid === "all") {
				this.visibleQids = this.questionnaireService.getAnsweredQuestionsForStep(this.currentStep);
				this.clearPreviousQuestionValidators();
			} else {
				this.setValidators();
				this.setValidatorsArray();
				this.visibleQids = this.questionnaireService.getAnsweredQuestionsForStep(this.currentStep);
			}
		});
	}
	
	openSite(num) {
		if(num===1){
			window.open("https://www.mizrahi-tefahot.co.il/login/bv5x83ut/index.html#/auth-page-he");
		}
		if(num===2){
			window.open("https://sc.mizrahi-tefahot.co.il/TFHLogin/index.html#/login");
		}
	 }

	createForm() {
		this.currentStep = this.questionnaireService.getStep("cycle-details");
		this.cycleDetails = this.fb.group({
			cyclePurpose:  this.questionnaireService.getQuestion(this.currentStep, "1").selectedAnswer,
			cycleAmount: this.questionnaireService.getQuestion(this.currentStep, "2").answer.fields[0].answerValue,
			isHigherThanTheExistingOne: this.questionnaireService.getQuestion(this.currentStep, "2-0").selectedAnswer,
			cycleMixture: CycleMixtureComponent.build(this.questionnaireService.getQuestion(this.currentStep, "2-1").answer.fieldsArray),// this.questionnaireService.getQuestion(this.currentStep, "2-1").answer.fields[0].answerValue,
			//'otherIncome': IncomesArrayComponent.buildIncomes(this.questionnaireService.getQuestion(this.currentStep, "4-1").answer.fieldsArray)
			externalBank: this.externalBank,
			externalMakorPropose:  this.externalMakorPropose,
			externalMortgageBalance : this.questionnaireService.getQuestion(this.currentStep, "5").answer.fields[0].answerValue,
			externalMonthlyRepayment: this.questionnaireService.getQuestion(this.currentStep, "6").answer.fields[0].answerValue,
			continueBranch:this.questionnaireService.getQuestion(this.currentStep, "10").answer.fields[0].answerValue,
			oshBank: this.questionnaireService.getQuestion(this.currentStep, "11").answer.fields[0].answerValue,
			inWhichCity: this.inWhichCity,
            externalValueOfProperty: this.questionnaireService.getQuestion(this.currentStep, "8").answer.fields[0].answerValue,
			internalAreCycleAllMorygage: this.questionnaireService.getQuestion(this.currentStep, "9").selectedAnswer,
			internalCycleAmount: this.questionnaireService.getQuestion(this.currentStep, "9-1").answer.fields[0].answerValue,
			internalTikNum: InternalTikNumArrayComponent.buildTikNum(this.questionnaireService.getQuestion(this.currentStep, "9-2").answer.fieldsArray),
			internalMaslol: InternalMaslolComponent.buildMaslol(this.questionnaireService.getQuestion(this.currentStep, "9-3").answer.fieldsArray),
            // internalProduct: this.questionnaireService.getQuestion(this.currentStep, "9-4").answer.fields[0].answerValue,


		});
	}

	setValidatorsArray() {
		this.questionnaireService.clearAllQuestionValidators(this.cycleDetails.controls, this.qFields, this.qArrFields);
		this.questionnaireService.setCurrentQuestionValidators(this.qID, this.cycleDetails.controls, this.qFields, "2", this.qArrFields);
	}
	setValidators() {
		// if (this.prevQID) {
		 	this.clearPreviousQuestionValidators();
		// }
		for (let i = 0; i < this.qFields[this.qID].length; i++) {
			let field = this.qFields[this.qID][i];
			this.cycleDetails.controls[field.name].setValidators(field.validators);
			this.cycleDetails.controls[field.name].updateValueAndValidity();
		}
		this.submitted = false;
	}

	clearPreviousQuestionValidators() {
		console.log("clearPreviousQuestionValidators()");

		let keys = Object.keys(this.qFields);

		for (let i = 0; i < keys.length; i++) {

			for(let j = 0; j < this.qFields[keys[i]].length; j++){
				this.cycleDetails.controls[this.qFields[keys[i]][j].name].setValidators(null);
				this.cycleDetails.controls[this.qFields[keys[i]][j].name].updateValueAndValidity();
			}
		}		
	}

	onSubmit({ value, valid }: { value: any, valid: boolean }) {
		console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>  onSubmit","value=", value,", valid=",valid);
		this.submitted = true;
		if (valid) {
			let q;
			let submitQID = (this.qID !== "all") ? this.qID : this.editQuestion;

			q = this.qFields[submitQID];

			let values = q.map(r => {
				return value[r.name];
			});
			this.questionnaireService.sendGA(this.currentStep,this.qID, values);
			this.nextClick(submitQID, values);
		}
	}

	nextClick(qID, answers) {
		if (answers) {
			this.questionnaireService.updateMetaData(this.currentStep, qID, answers);
			this.questionnaireService.saveAndNavigate(this.currentStep, qID, answers);
		}
	}

	editQuestionChange(qid){
		this.qID = qid;
		this.setValidators();
		this.setValidatorsArray();
	}

	canOverValidator(qName: string ) {
		return (control: AbstractControl): { [key: string]: any } => {
			let step2 = this.questionnaireService.getStepByID("2");
			let getQuestion = this.questionnaireService.getQuestion;
			let cycleDetailsStep2Question1Answer = (getQuestion(step2, "1").selectedAnswer[0]);//matara aalvaa
			if (cycleDetailsStep2Question1Answer === "allPurposecycles" && control.value === "NO") {
				return  { canOverValidator: true };
			}

			return null;
		}
	}

	// external: bank
    filterBanks(bankName: string) {
        return this.banksList.filter(item =>
            item.mtext.toLowerCase().indexOf(bankName.toLowerCase()) === 0);
    }

	checkBankchoose(value1: string,value2: string) {
		if(value1==value2){
			this.checkBank = 1
		}
	}

	onSearchBankChange(searchValue: string): void {  
		this.checkBank = 0
	}

	isInBankList() {
		return (control: AbstractControl): { [key: string]: any } => {
			if (control.value.length>0) {
				let bankBingo = this.banksList.filter(bank =>bank.mtext === control.value);
					if (bankBingo.length < 1) {
						return {isNotInBankList: true};
					}
					else return null;
			}
		}
	}

	// external: propose makor
	filterProposeMakor(value: string) {
		const filterValue = value.toLowerCase();
		return this.optionsMakorPurposeList.filter(item => item.label.toLowerCase().includes(filterValue));
	}

	checkProposeMakorchoose(value1: string,value2: string) {
		if(value1==value2){
			this.checkProposeMakor = 1
		}
	}

	onSearchProposeMakorChange(searchValue: string): void {  
		this.checkProposeMakor = 0
	}

	// external: city
	isInCityList() {
		return (control: AbstractControl): { [key: string]: any } => {
			if (control.value.length>0) {
				let cityBingo = this.citiesList.filter(city =>city.name === control.value);
					if (cityBingo.length < 1) {
						return {isNotInCityList: true};
					}
					else return null;
			}
		}
	}
	

	filterCity(name: string) {
		return this.citiesList.filter(item =>
			item.name.toLowerCase().indexOf(name.toLowerCase()) === 0);	
    }

    // getSystemTbl() {

    //     this.systemTablesService.getTable("398").subscribe(

    //         data => {
    //             if (data && data.length > 0) {
    //                 console.log("get system tables sucseed");
    //                 this.banksList = data;
    //                 this.banksFilterList = this.externalBank.valueChanges
    //                     .pipe(
    //                     startWith(''),
    //                     map(bank => bank ? this.filterBanks(bank) : this.banksList.slice())
    //                     );
    //             } else if (data.errorCode) {
    //                 console.log("get system tables error errorCode: " + data.errorCode);
    //             }
    //             else {
    //                 console.log("get system tables error");
    //             }
    //         },
    //         error => {
    //             console.log("get system tables error: " + error);
    //         }
    //     );
    // }

	
}



// WEBPACK FOOTER //
// ./src/app/cycle-details/cycle-details.component.ts